/**
 * Enum of status-bar svg types
 */
export const svgTypes = {
    SERVER_CLOCK: 'localClock',
    LOCAL_CLOCK: 'localClock',
    SESSION_CLOCK: 'sessionClock',
    CROWN: 'crown',
};
